import { Navigate, Route, Routes } from 'react-router';
import { LoginPage } from './pages/LoginPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ChangePasswordPage } from './pages/ChangePasswordPage';
import { ProfilePage } from './pages/ProfilePage';
import { ProfileChangePasswordPage } from './pages/ProfileChangePasswordPage';
import { HomePage } from './pages/HomePage';
import { LogoutPage } from './pages/LogoutPage';
import { SetPasswordPage } from './pages/onboarding/SetPasswordPage';
import { OnboardingPage } from './pages/onboarding/OnboardingPage';
import { SearchPage } from './pages/tutors/SearchPage';
import { TutorViewPage } from './pages/tutors/TutorViewPage';
import { BookingsPage } from './pages/bookings/BookingsPage';
import { TutorBookingsPage } from './pages/bookings/TutorBookingsPage';
import { TutorEditProfilePage } from './pages/tutor/TutorEditProfilePage';
import { EarningsPage } from './pages/earnings/EarningsPage';
import { ReferralsPage } from './pages/referrals/ReferralsPage';
import { RequireAuth } from './components/RequireAuth';
import { RequireRole } from './components/RequireRole';
import { RequirePublishedTutor } from './components/RequirePublishedTutor';
import { RequireEditableTutorProfile } from './components/RequireEditableTutorProfile';
import { DashboardLayout } from './components/DashboardLayout';

export function App() {
  return (
    <Routes>
      {/* Public / auth-flow routes — no dashboard shell */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/logout" element={<LogoutPage />} />
      <Route
        path="/onboarding/set-password"
        element={<SetPasswordPage />}
      />
      <Route
        path="/change-password"
        element={
          <RequireAuth allowMustChange>
            <ChangePasswordPage />
          </RequireAuth>
        }
      />

      {/* Dashboard routes — all wrapped in the sidebar+header shell */}
      <Route element={<RequireAuth><DashboardLayout /></RequireAuth>}>
        <Route path="/" element={<HomePage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/profile/change-password" element={<ProfileChangePasswordPage />} />

        {/* Onboarding lives inside the dashboard shell — tutor sees sidebar steps */}
        <Route
          path="/onboarding"
          element={
            <RequireRole role="tutor">
              <RequireEditableTutorProfile>
                <OnboardingPage />
              </RequireEditableTutorProfile>
            </RequireRole>
          }
        />
        <Route
          path="/onboarding/:step"
          element={
            <RequireRole role="tutor">
              <RequireEditableTutorProfile>
                <OnboardingPage />
              </RequireEditableTutorProfile>
            </RequireRole>
          }
        />

        <Route
          path="/tutors"
          element={
            <RequireRole role="parent">
              <SearchPage />
            </RequireRole>
          }
        />
        <Route
          path="/tutors/:id"
          element={
            <RequireRole role="parent">
              <TutorViewPage />
            </RequireRole>
          }
        />
        <Route
          path="/tutor/public-profile/:id"
          element={
            <RequireRole role="tutor">
              <TutorViewPage />
            </RequireRole>
          }
        />
        <Route
          path="/bookings"
          element={
            <RequireRole role="parent">
              <BookingsPage />
            </RequireRole>
          }
        />
        <Route
          path="/tutor/profile"
          element={
            <RequireRole role="tutor">
              <RequirePublishedTutor>
                <TutorEditProfilePage />
              </RequirePublishedTutor>
            </RequireRole>
          }
        />
        <Route
          path="/tutor/bookings"
          element={
            <RequireRole role="tutor">
              <RequirePublishedTutor>
                <TutorBookingsPage />
              </RequirePublishedTutor>
            </RequireRole>
          }
        />
        <Route
          path="/tutor/earnings"
          element={
            <RequireRole role="tutor">
              <RequirePublishedTutor>
                <EarningsPage />
              </RequirePublishedTutor>
            </RequireRole>
          }
        />
        <Route
          path="/referrals"
          element={
            <RequireRole role="parent">
              <ReferralsPage />
            </RequireRole>
          }
        />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
